// UX-2026-05-27: /settings 单独页 — 左侧 nav 5 区 + 右侧 active section
//
// 路由用 ?tab=X 让用户可以分享/书签直接跳到某个 tab.
// 不传 tab 时默认 account.

import { useSearchParams } from "react-router-dom";

import { SettingsPanel, type SettingsTab } from "../components/SettingsPanel";
import { useI18n, type DictKey } from "../lib/i18n";

const TABS: { id: Exclude<SettingsTab, "all">; key: DictKey }[] = [
  { id: "account", key: "settings.tab.account" },
  { id: "security", key: "settings.tab.security" },
  { id: "ai", key: "settings.tab.ai" },
  { id: "display", key: "settings.tab.display" },
  { id: "about", key: "settings.tab.about" },
];

export function SettingsPage() {
  const [params, setParams] = useSearchParams();
  const { t } = useI18n();
  const active = (params.get("tab") as SettingsTab) || "account";

  const switchTab = (id: SettingsTab) => {
    const next = new URLSearchParams(params);
    next.set("tab", id);
    setParams(next, { replace: true });
  };

  return (
    <section className="page page--settings settings-layout">
      <aside className="settings-nav" aria-label="设置导航">
        <h1 className="settings-nav__title">{t("nav.settings")}</h1>
        <ul className="settings-nav__list">
          {TABS.map((tab) => (
            <li key={tab.id}>
              <button
                type="button"
                className={
                  active === tab.id
                    ? "settings-nav__item settings-nav__item--active"
                    : "settings-nav__item"
                }
                onClick={() => switchTab(tab.id)}
              >
                {t(tab.key)}
              </button>
            </li>
          ))}
        </ul>
      </aside>
      <div className="settings-content">
        <SettingsPanel activeTab={active} />
      </div>
    </section>
  );
}
